import { gtag } from './gtag';

enum Categories {
  SIMULATION = 'SIMULATION',
}

enum Actions {
  SIMULATE_CLICK = 'SIMULATE_CLICK',
}

enum StaticLabels {
  SIMULATE = 'SIMULATE',
}

function sendEvent(
  category: string,
  action: string,
  label: string,
  eventValue?: number,
) {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value: eventValue,
  });
}

export function simulateClickEvent() {
  sendEvent(
    Categories.SIMULATION,
    Actions.SIMULATE_CLICK,
    StaticLabels.SIMULATE,
  );
}

type ChamberEvent =
  | 'chamber_viewer_opened'
  | 'chamber_filter_changed'
  | 'chamber_feed_size_changed'
  | 'chamber_auto_simulation'
  | 'chamber_reference_set'
  | 'chamber_reference_removed'
  | 'chamber_simulation_run';

export function chamberEvent(
  event: ChamberEvent,
  parameters?: Record<string, string | undefined>,
) {
  gtag('event', event, parameters);
}
